import axios from "axios";

export default class MembershipController {
    static async index(clubId: string | number) {
        const result = await axios.get<Club.Resources.MembershipPartial[]>(`/api/club/customer/clubs/${clubId}/memberships`)
        return result.data
    }

    static async store(clubId: string | number, secret: string) {
        const result = await axios.post<Resources.Membership>(`/api/club/customer/clubs/${clubId}/memberships`, { secret })
        return result.data
    }

    static async show(clubId: string | number, memberId: string | number) {
        const result = await axios.get<Club.Resources.Membership>(`/api/club/customer/clubs/${clubId}/memberships/${memberId}`)
        return result.data
    }

    static async destroy(clubId: string | number, memberId: string | number) {
        const result = await axios.delete<void>(`/api/club/customer/clubs/${clubId}/memberships/${memberId}`)
        return result.data
    }
}